<template>
	<div class="formTabWrapper" :class="{ 'onlyView': getPermissionAction }">
		<div class="formTabTableWrap">
			<div class="formTabTableWrap_top">
				<div class="formTabTableWrap_top-title">Contracts</div>
				<div class="formTabTableWrap_top-add">
					<v-btn
							@click="refreshFilters" type="button"
							depressed
							class="mainBtn mainBtn-text iconHoverRotate"
					>
						<span class="btnIco"><svg-sprite icon-id="refresh" width="20" height="20"></svg-sprite></span>
						<span class="btnText">Refresh filters</span>
					</v-btn>
					<v-btn
							:disabled="!id" @click="onContractPopup(true)" type="button"
							depressed
							class="mainBtn mainBtn-text"
					>
						<span class="btnIco"><svg-sprite icon-id="addItem" width="20" height="20"></svg-sprite></span>
						<span class="btnText">Add driver contract</span>
					</v-btn>

				</div>
			</div>
			<div class="formTabTableWrap_body">

				<v-data-table
						:headers="headers"
						:items="items"
						:sort-by.sync="sortBy"
						:sort-desc.sync="sortDesc"
						class="contractTable"
						:search="search"
						hide-default-footer
						hide-default-header
						hide-default-body
						disable-pagination
						fixed-header
				>
					<template v-slot:header="{ props: { headers } }">
						<thead class="v-data-table-header">
						<tr class="head">
							<th
									:class="[{'filter-active': filterClasses[item.value]}]"
									v-for="(item, index) in headers"
									:key="index"
									class="text-start sortable position-relative"
									:id="'container-'+item.value"
							>
								<div class="filterIcons">
									<sort-btn
											:sortDesc="sortDesc"
											:sortBy="sortBy"
											:data-sort="item.value"
											@updateToggleOrder="toggleOrder"
									></sort-btn>
									<span class="headText" :class="{'headText_sorted': getSortColor(sortBy, item.value)}">{{
											item.text
										}}</span>
									<filter-drop-down v-if="item.func" :item="item">
										<filter-table
												@change-sort="changeSort"
												@create-refresh="createRefresh"
												@filter-created="filterCreated"
												@updateFilterListAll="onFilteredAll(item)"
												:data-filter="driversFilter[item.value]"
												:type-filter="item.model"
												:model-filter="item.value"
												:filter-update="filterUpdate"
												:is-disabled="filterPreloader"
												:isRefresh="isRefresh"
												:uniqId="uniqId"
										></filter-table>
									</filter-drop-down>
								</div>
							</th>
							<th width="120"></th>
						</tr>
						</thead>
					</template>
					<template v-slot:body="{ items }">
						<tbody>
						<template v-for="(item, idx) in items">
							<table-tr
									:item="item"
									:filterStatus="checkClasses['filter_status']"
									:checkClasses="checkClasses"
									:key="item.id"
									:isHideFile="!getAcceptFiles(item.file)"
									@updateEditRow="onEditRow"
									@updatePreviewAction="previewAction"
									@updateDownload="onDownload"
									:idx="idx"
									@updateDeleteItem="onDeleteItem($event, idx)"
							></table-tr>
						</template>
						<tr class="tableBottom">
							<td>n: <span>{{ items.length }}</span></td>
							<td :key="i" v-for="i in 8"></td>
						</tr>
						</tbody>
					</template>
				</v-data-table>

			</div>
		</div>

		<a style="display: none" :href="downloadLink" target="_blank" download class="d-none" ref="downloadFile"></a>

		<contract-popup
				v-if="isContractPopup"
				:driverList="driverList"
				:driverId="id"
				:row="row"
				@updateClose="onContractPopup"
				@updateView="previewAction"
		></contract-popup>

	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// components
import FilterTable
from "@/components/Maintenance/Customer/CustomerForm/SixthTab/FilterTable/FilterTable.vue";
import ContractPopup
from "@/components/Maintenance/Drivers/DriversForm/ThirdTab/ContractPopup/ContractPopup.vue";
import SortBtn from "@/shared/SortBtn/SortBtn.vue";
import TableTr from "@/components/Maintenance/Drivers/DriversForm/ThirdTab/TableTr/TableTr.vue";
import FilterDropDown from "@/shared/FilterDropDown/FilterDropDown.vue";
// constants
import { driverContractHeader } from "@/constants/defaultHeader";
// helper
import getUniqId from "@/helper/getUniqId";

export default {
	name: "ThirdTab",
	components: {
		FilterTable,
		ContractPopup,
		TableTr,
		SortBtn,
		FilterDropDown
	},
	props: {
		listItems: Array,
		driversFilter: Object,
		driverList: Array,
		id: Number,
		getPermissionAction: Boolean
	},
	watch: {
		listItems(val) {
			this.items = val;
		}
	},
	computed: {
		...mapGetters([ 'customersList' ]),
		headers() {
			return driverContractHeader;
		},
		filterClasses: {
			get() {
				return this.checkClasses;
			},
			set(arr) {
				const obj = {};
				for (const i in arr) {
					obj[i] = arr[i].length;
				}
				this.checkClasses = obj;
			},
		},
		items: {
			get() {
				return this.list;
			},
			set(arr) {
				this.list = arr;
			},
		},
	},
	data() {
		return {
			isContractPopup: false,
			downloadLink: null,
			filterUpdate: false,
			sortBy: "",
			sortDesc: false,
			search: "",
			menu: false,
			filtersMarker: {},
			filters: {},
			filtersList: {},
			list: this.listItems,
			checkClasses: {},
			row: null,
			isRefresh: null,
			filterPreloader: false,
			uniqId: { key: '', id: '' },
		};
	},
	methods: {
		...mapActions([ 'onDriversFilter', 'getContractDelete', 'onContractShow', 'getDriversList' ]),
		onFilteredAll(item) {
			this.uniqId = {
				id: getUniqId(),
				key: item.value
			};
		},
		getSortColor(sortBy, value) {
			return sortBy === value || (sortBy && value.includes(sortBy));
		},
		async onEditRow(id) {
			const { row } = await this.onContractShow(id);
			this.row = row;
			this.isContractPopup = true;
		},
		onContractPopup(value) {
			this.isContractPopup = value;
			this.row = null;
		},
		getAcceptFiles(value) {
			const accept = [ 'png', 'jpeg', 'bmp', 'png', 'pdf', 'gif', 'jpg' ];
			const str = value && value.split('.').pop().toLowerCase();

			return accept.includes(str);
		},
		onDeleteItem(id, idx) {
			this.getContractDelete({ id });
			this.$emit('updateContract', idx);
		},
		onDownload(url) {
			this.downloadLink = url;
			this.$nextTick(() => {
				this.$refs.downloadFile.click();
			});
		},
		previewAction(file) {
			this.$emit('updatePreviewAction', file);
		},
		onActions(values) {
			this.$emit('updateActions', values);
		},
		async refreshFilters() {
			this.search = "";
			this.sortDesc = false;
			this.sortBy = "";
			this.items = this.listItems;
			this.isRefresh = getUniqId();

			if (Object.values(this.filterClasses)) {
				for (const i in this.filters) {
					this.filters[i] = [];
				}

				this.filterUpdate = true;
			}

			await this.onDriversFilter({ id: this.id, filters: {} });
		},

		createRefresh(model) {
			this.filtersMarker[model] = true;
			if (!Object.values(this.filtersMarker).includes(false)) {
				this.filterUpdate = false;
				for (const i in this.filtersMarker) {
					this.filtersMarker[i] = true;
				}
			}
			this.filterClasses = this.filters;
		},

		filterCreated(model) {
			this.filtersMarker[model] = false;
		},
		async changeSort({ key, value, model }) {
			switch (model) {
				case 'date':
					this.filters[key] = value;
					this.filterClasses[key] = !!this.filters[key]['from'];
					break;
				case 'number':
					this.filters[key] = value;
					this.filterClasses[key] = !!this.filters[key]['type'];
					break;
				case 'note':
					this.filters[key] = value;
					this.filterClasses[key] = !!this.filters[key].length;
					break;
				case 'options':
					this.filters[key] = Number(value);
					this.filterClasses[key] = !!this.filters[key].length;
					break;
				case 'checkbox':
					this.filters[key] = Number(value);
					break;
				default:
					this.filters[key] = value.map(item => item);
					this.filterClasses[key] = !!this.filters[key].length;
			}

			this.filterPreloader = true;
			await this.onDriversFilter({ id: this.id, filters: this.filters });
			this.filterPreloader = false;
		},
		toggleOrder(val) {
			switch (val) {
				case 'filter_status':
					this.sortBy = 'status';
					break;
				case 'filter_create_at':
					this.sortBy = 'create_at';
					break;
				case 'filter_date_start':
					this.sortBy = 'date_start';
					break;
				case 'filter_date_end':
					this.sortBy = 'date_end';
					break;
				case 'filter_file_name':
					this.sortBy = 'file_name';
					break;
				case 'filter_created_by':
					this.sortBy = 'created_by';
					break;
				case 'filter_contract_type':
					this.sortBy = 'contract_type';
					break;
				case 'filter_id':
					this.sortBy = 'id';
					break;
				default:
					this.sortBy = val;
			}

			this.sortDesc = !this.sortDesc;
		},
		onEditActions(values) {
			this.$emit('updateEditActions', values);
		},
		onDeleteHandler(value) {
			this.$emit('onDeleteAction', value);
		}
	},
	created() {
		for (let i = 0; i < this.headers.length; i++) {
			this.filtersMarker[this.headers[i].value] = true;
			this.checkClasses[this.headers[i].value] = false;
			this.filters[this.headers[i].value] = [];
			this.filtersList[this.headers[i].value] = [];
		}
	}
};
</script>

<style scoped lang="scss">
@import "@/assets/style/components/formTab/formTabTableWrap";
</style>

<!--<style lang="scss">-->
<!--@import "thirdTabGlobal";-->
<!--</style>-->
<!--<style scoped lang="scss">-->
<!--@import "thirdTab";-->
<!--</style>-->
